import { useBreakpointValue } from '@stockx/ui';
import useShowWhereAreYou from '@app/shell/AppLayout/components/WhereAreYou/hooks/useShowWhereAreYou';

const useShowLocationSelectorBanner = () => {
  const showWhereAreYou = useShowWhereAreYou();
  const { isMobile } = useBreakpointValue();

  return showWhereAreYou && !isMobile;
};

export default useShowLocationSelectorBanner;
